import { render, staticRenderFns } from "./sensordetail.vue?vue&type=template&id=3abfa312&scoped=true"
import script from "./sensordetail.vue?vue&type=script&lang=js"
export * from "./sensordetail.vue?vue&type=script&lang=js"
import style0 from "./sensordetail.vue?vue&type=style&index=0&id=3abfa312&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abfa312",
  null
  
)

export default component.exports